import { produce } from 'immer';

import { RemoveInternalMarketerProduct } from '../../../actions/marketer/internal/removeInternalMarketerProduct';
import { MarketerState } from '../../../typings/marketers';

export function removeInternalMarketerProduct(
    state: MarketerState,
    action: RemoveInternalMarketerProduct
): MarketerState {
    return produce(state, draft => {
        draft.marketer.ownProducts = draft.marketer.ownProducts.filter(item => item.id !== action.productId);
    });
}
